import _ from 'underscore';

import { Messages } from '~src/codegen/Localize';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { ISiteNameWithId } from '~src/siteManagement/serverApi/types/ISiteNameWithId';
import { ExplorableItemType, SpaceInfoItemType } from '~src/spacesPlatform/models/ContentType';
import { INamedItem } from '~src/spacesPlatform/models/resourceParts';
import { IUser } from '~src/userManagement/users/serverApi/types/IUser';
import { IView } from '~src/views/ServerApi/types/IView';

import { IAccelerationTask } from '../../serverApi/types/IAccelerationTask';
import { AdminAccelerationStatus, IAccelerationTaskInfo } from '../IAccelerationTaskInfo';

export module AccelerationTaskMapper {

  export function map(
    tasks: IAccelerationTask[],
    views: _.Dictionary<IView>,
    workbooks: _.Dictionary<INamedItem>,
    projects: _.Dictionary<INamedItem>,
    users: _.Dictionary<IUser>,
    sites: _.Dictionary<ISiteNameWithId>): IAccelerationTaskInfo[] {

    if (tasks.length === 0) {
      return [];
    }

    var lastMonthViewCountMax = 0;
    Object.values(views).forEach(view =>
      lastMonthViewCountMax = Math.max(lastMonthViewCountMax, view.usageInfo.hitsLastOneMonthTotal));

    if (tasks.length === 0) {
      return [];
    }

    var lastMonthViewCountMax = 0;
    Object.values(views).forEach(view =>
      lastMonthViewCountMax = Math.max(lastMonthViewCountMax, view.usageInfo.hitsLastOneMonthTotal));

    return _.map(tasks, (task: IAccelerationTask) => {
      return {
        id: task.viewId,
        contentType: 'accelerationTask' as ExplorableItemType,
        name: views[task.viewId].name,
        luid: views[task.viewId].luid,
        workbook: workbooks[task.workbookId],
        project: projects[task.projectId],
        owner: users[task.userId],
        view: { ...views[task.viewId], contentType: 'view' as SpaceInfoItemType},
        site: sites[task.siteId],
        lastMonthViewCount: views[task.viewId].usageInfo.hitsLastOneMonthTotal,
        avgLoadTimeWithMaterializationInSec: setupAvgLoadColumnValue(task.avgLoadTimeWithMaterialization),
        avgLoadTimeWithoutMaterializationInSec: setupAvgLoadColumnValue(task.avgLoadTimeWithoutMaterialization),
        lastMonthViewCountMax: lastMonthViewCountMax,
        lastMonthJobCount: task.lastMonthJobCount || 0,
        lastMonthJobAvgTimeInSec: task.lastMonthJobAvgTimeInSec || 0,
        disallowed: isDisallowed(task.accelerationStatus),
        accelerationStatus: task.accelerationStatus || AdminAccelerationStatus.UNKNOWN,
        estimatedDiskUsageKb: task.estimatedDiskUsageBytes / 1024.0,
        updatedAt: task.updatedAt,
      };
    });
  }

  /**
  * Checks if the view has been suspended based on the received passed acceleration status
  * @param viewAccelerationStatus acceleration status for a view
  * @returns true if admin has suspended the view else returns false
  */
  function isDisallowed(viewAccelerationStatus: string) {
    return viewAccelerationStatus === AdminAccelerationStatus.SUSPENDED ||
    viewAccelerationStatus === AdminAccelerationStatus.SYSTEM_SUSPENDED;
  }

  function setupAvgLoadColumnValue(loadTimeInSec: number): string {
    if (loadTimeInSec === undefined || isNaN(loadTimeInSec) || loadTimeInSec < 0) {
      return Messages.notApplicable();
    } else if (loadTimeInSec < 0.1) {
      return Messages.lessThanPointOne();
    }

    return L10n.localizedFloat(loadTimeInSec);
  }

}
